import React, { PureComponent } from "react";
import PageLink from "../../../components/Page/PageLink";
import Footer from "../../../components/Footer/Footer";

class Interface_overview extends PureComponent {
  render() {
    return (
      <div className="row" id="interface_overview">
        <div className="col-md-6">
          <div className="contentLight">
            <section>
              <h2>Interface Overview</h2>
              <p>
                In this section, we are going to cover everything you need to
                know about modifying, manipulating and creating interfaces in
                the Nexoid application. Before we can begin, we need to have a
                functional and practical understanding of JSON and how the
                interface or module hierarchy in Nexoid works.
              </p>
              <p>
                Everything in the interface from the colour of an icon, to what
                data fields exist and in what order, to how free text search
                operations function over and weight differently in different
                data fields is controlled through a JSON object the user
                receives when signing in. This means for changes to be applied,
                a user will need to sign out and sign back in.
              </p>
              <p>
                For those of you who have not used to JSON, JSON can be thought
                of as a compressed version of XML. Like XML JSON is a highly
                flexible way of storing data with non-standard structures.
              </p>
              <p>
                If you are not familiar with JSON, continue to the working with
                JSON section, and we will give you a high-level overview of how
                JSON syntax works. If you are already familiar with JSON, you
                can continue straight through to the inheritance and hierarchy
                section which will give you a better understanding of how Nexoid
                modules work in layers and how you can manipulate them.
              </p>
              <Footer
                section={this.props.section}
                article={this.props.article}
                routeParams={this.props.routeParams}
              />
            </section>
          </div>
        </div>
        <div className="hidden-sm-xs col-md-6 darkCol">
          <div className="contentDark"></div>
        </div>
      </div>
    );
  }
}

export default Interface_overview;



// WEBPACK FOOTER //
// ./src/components/knowlege/interface/Interface_overview.js